// import { useState } from 'react'
import { notification } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import ErrorBoundary from "./Components/ErrorBoundary";
import AllRoutes from "./routes/AllRoutes";
import {
  getStreakData,
  getUserAllFormsDetails,
  getUserBasicInfo,
  getUserCalendarDetails,
} from "./slices/userSlice";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const userAttributes = JSON.parse(
    localStorage?.getItem("userAttributes") ?? "{}"
  );
  const streakData = useSelector((state) => state.user.streakData);
  console.log("🚀 ~ App ~ streakData:", streakData?.streak);
  const liveNotification = useSelector(
    (state) => state.user.liveNotificationBySme
  );
  const [showAlert, setShowAlert] = useState(false);
  console.log(userAttributes, "==userAttributes:app.jsx");
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (placement) => {
    api.info({
      message: `Notification: ${liveNotification?.message}`,
      description: (
        // <Context.Consumer>{({ name }) => `Hello, ${name}!`}</Context.Consumer>
        <p>{liveNotification?.data?.Description}</p>
      ),
      placement,
      duration: null,
    });
  };
  console.log({ liveNotification });
  useEffect(() => {
    // const userAttr = localStorage.getItem("userAttributes");
    // const userAttributes = userAttr ? JSON.parse(userAttr) : {};
    // console.log(userAttributes, " 00userAttributes");
    // dispatch(setuserAttributesReducer(userAttributes));
    if (isAuthenticated) {
      dispatch(getUserBasicInfo())
        // .unwrap()
        .then((res) => {
          console.log(res, "asddddddddddd");
        })
        .catch((e) => {
          console.log(e);
        });
      dispatch(getUserCalendarDetails()).unwrap();
      dispatch(getUserAllFormsDetails()).unwrap();
      dispatch(getStreakData()).unwrap();
    }
  }, [dispatch, isAuthenticated]);
  useEffect(() => {
    if (streakData?.streak === 1) {
      navigate("/welcome");
    }
  }, [streakData?.streak === 1]);

  // useEffect(() => {
  //   if (liveNotification) {
  //     setShowAlert(true);
  //     const timer = setTimeout(() => {
  //       setShowAlert(false);
  //     }, 1000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [liveNotification])
  return (
    <ErrorBoundary>
      {contextHolder}
      {showAlert && openNotification("topLeft")}
      <AllRoutes showAlert={showAlert} setShowAlert={setShowAlert} />
      <ToastContainer />
    </ErrorBoundary>
  );
}

export default App;
